import { CampaignsListForm } from '@crm/features/campaigns/components'
import {
  AssignTo,
  ChangeStatus,
  DeleteLeads,
  SendClientForm,
  SetTag
} from '@crm/features/leads/components'

const actionsType = {
  assignTo: AssignTo,
  setTag: SetTag,
  sendLeadForm: SendClientForm,
  campaignsListForm: CampaignsListForm,
  changeStatus: ChangeStatus,
  delete: DeleteLeads
}

export type ActionsLeadType = keyof typeof actionsType

type Props = {
  leads?: number[]
  type?: ActionsLeadType
  onClose: () => void
  onSubmit?: () => void
}

export const ActionsHandler = ({
  leads,
  type,
  onClose,
  onSubmit = () => null
}: Props) => {
  if (!type) return null

  const Component = actionsType[type]

  if (!Component) return null

  return <Component open leads={leads} onClose={onClose} onSubmit={onSubmit} />
}
